import angular from 'angular'
import './tags.service'

angular.module('admin.tags', ['admin.tags.service']).controller('TagsAdminCtrl', TagsAdminCtrl)

/** @ngInject */
function TagsAdminCtrl(TagsService) {
  var vm = this
  vm.items = []
  vm.create = false

  function reloadPaginationSort() {
    vm.totalUsers = 0
    vm.usersPerPage = 25
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
    vm.sortType = 'id-desc'
    vm.sortReverse = false
  }

  reloadPaginationSort()
  load(1)

  var oldSortType
  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    TagsService.listAdmin(vm.oldPage, 25, vm.sortType).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < result.results.length; i++) {
        result.results[i].editing = false
        result.results[i]['ts-m'] = new Date(
          parseInt(
            result.results[i]['ts-m']
              .toString()
              .substring(0, result.results[i]['ts-m'].toString().length - 3),
          ),
        )
      }
      vm.items = result.results
      vm.sortType = oldSortType
    })
  }

  vm.pageChanged = function(newPage) {
    vm.sortType = oldSortType
    load(newPage)
  }

  vm.add = function() {
    vm.create = true
    vm.items.unshift({
      id: 0,
      name: '',
      editing: true,
    })
  }

  vm.edit = function(item) {
    item.editing = !item.editing
  }

  vm.save = function(item) {
    vm.create = false
    if (item.id !== undefined && item.id !== '' && item.id !== 0) {
      delete item['ts-m']
      delete item.ts
      TagsService.update(item.id, item).then(function() {
        reloadPaginationSort()
        load(vm.pagination.current)
      })
    } else {
      TagsService.save(item).then(function() {
        reloadPaginationSort()
        load(vm.pagination.current)
      })
    }
  }

  vm.cancel = function(item) {
    if (item.id === 0) {
      vm.items.remove(item)
    }
    item.editing = !item.editing
    vm.create = false
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Delete this tag?',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          TagsService.remove(item.id).then(
            function() {
              if (vm.items.length === 1 || vm.items.length === 25) {
                $state.reload()
              } else {
                reloadPaginationSort()
                load(vm.pagination.current)
              }
            },
            function(err) {
              swal(err.error.message, '', 'error')
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.sort = function(type) {
    vm.sortReverse = !vm.sortReverse
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }
    load(vm.pagination.current)
  }
}
